import { render } from "./registered-personnel-count.vue?vue&type=template&id=6f269b20&scoped=true"
import script from "./registered-personnel-count.vue?vue&type=script&lang=js"
export * from "./registered-personnel-count.vue?vue&type=script&lang=js"

import "./registered-personnel-count.vue?vue&type=style&index=0&id=6f269b20&scoped=scoped&lang=less"

import exportComponent from "D:\\project\\BidData\\code\\xyf_web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f269b20"]])

export default __exports__